import React from 'react';
import { Table, InputNumber, Input } from 'antd';
import type { ColumnsType } from 'antd/es/table';

interface AssessmentDataItem {
  key: string;
  item: string;
  details: string | number;
  score: number;
  proportionScore: number;
}

interface SafetyAssessmentTableProps {
  isViewMode: boolean;
  title: string;
  data: AssessmentDataItem[];
  onChange: (data: AssessmentDataItem[]) => void;
}

const SafetyAssessmentTable: React.FC<SafetyAssessmentTableProps> = ({ isViewMode, title, data, onChange }) => {
  const handleDetailChange = (value: number | null, key: string) => {
    const newData = data.map(item =>
      item.key === key ? { ...item, details: value ?? 0 } : item
    );
    onChange(newData);
  };

  const columns: ColumnsType<AssessmentDataItem> = [
    {
      title: title,
      dataIndex: 'item',
      key: 'item',
      width: '35%',
    },
    {
      title: '详情',
      dataIndex: 'details',
      key: 'details',
      width: '25%',
      render: (text: string | number, record: AssessmentDataItem) => {
        const unitMap: { [key: string]: string } = {
          age: '岁',
          drivingExperience: '年',
          afterServiceScore: '分',
          safetyAwareness: '分',
          personalityTrait: '分',
          communicationSkill: '分',
          claimCount: '次',
          speedingCountPer100km: '次/百公里',
          phoneUseCountPer100km: '次/百公里',
          frequentLaneChangeCountPer100km: '次/百公里',
          nearCollisionCountPer100km: '次/百公里',
          rapidAccelDecelCountPer100km: '次/百公里',
          emergencyBrakeCountPer100km: '次/百公里',
          longEyeClosureCountPer100km: '次/百公里',
          distractionCountPer100km: '次/百公里',
          smokingCountPer100km: '次/百公里',
        };
        const unit = unitMap[record.key] || '';

        // 编辑模式下可以修改
        if (isViewMode) {
          return unit ? `${text} ${unit}` : text;
        }
        
        return (
          <InputNumber
            value={typeof text === 'number' ? text : 0}
            onChange={(value) => handleDetailChange(value, record.key)}
            addonAfter={unit}
            style={{ width: '100%' }}
            min={0}
          />
        );
      },
    },
    {
      title: '得分',
      dataIndex: 'score',
      key: 'score',
      width: '20%',
    },
    {
      title: '占比分值',
      dataIndex: 'proportionScore',
      key: 'proportionScore',
      width: '20%',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      bordered
      size="small"
      style={{ marginBottom: 24 }}
    />
  );
};

export default SafetyAssessmentTable;
